import React from "react";
import PropTypes from "prop-types";
import OutlinedLink from "components/views/atoms/OutlinedLink";
import VisitHub from "components/views/atoms/OutlinedLinkContent/VisitHub";
import GA from "components/utils/GA";

const navigateVisitHub = (_lbl) => {
  GA.event({
    category: "homepage",
    action: "visit_hub_link",
    label: _lbl,
  });
  window.open(_lbl, '_blank');
}

const OuttlinedVisitHub = ({ LinkLabel, className, doRender }) => {
  const classes = ["OuttlinedVisitHub"];
  if (className) classes.push(className);
  if(doRender !== "null"){
    return (
      <OutlinedLink className={classes.join(" ")} onClick={() => navigateVisitHub(LinkLabel)}>
        <VisitHub />
      </OutlinedLink>
    );
   }
  return (
    <></>
  );
};

OuttlinedVisitHub.displayName = "OuttlinedVisitHub";

OuttlinedVisitHub.propTypes = {
  className: PropTypes.string,
  LinkLabel : PropTypes.string,
  doRender : PropTypes.string
};

OuttlinedVisitHub.defaultProps = {
  className: null,
  LinkLabel : "",
  doRender : ""
};

export default OuttlinedVisitHub;
